"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useQuery = exports.buildQuery = exports.QueryUtils = void 0;
var _lodash = require("lodash");
var _reactRouterDom = require("react-router-dom");
var _queryString = require("query-string");
var _react = require("react");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var useQuery = function useQuery() {
  var history = (0, _reactRouterDom.useHistory)();
  var _useLocation = (0, _reactRouterDom.useLocation)(),
    search = _useLocation.search;
  var query = (0, _react.useMemo)(function () {
    return (0, _queryString.parse)(search);
  }, [search]);
  var mergeQuery = function mergeQuery(changes) {
    return history.push({
      search: buildQuery(_objectSpread(_objectSpread({}, query), changes))
    });
  };

  /**
   * Replace the current query string with the new changes
   * @param {unknown} changes
   * @returns
   */
  var replaceQuery = function replaceQuery(changes) {
    return history.push({
      search: buildQuery(changes)
    });
  };
  return {
    query: query,
    mergeQuery: mergeQuery,
    replaceQuery: replaceQuery
  };
};
exports.useQuery = useQuery;
var buildQuery = function buildQuery(query) {
  var queryString = (0, _queryString.stringify)(query);
  return queryString ? "?".concat(queryString) : '';
};

// Helpful for query param arrays (when there's just one it may get parsed as a string)
exports.buildQuery = buildQuery;
var castArray = function castArray(value) {
  if (!value) {
    return [];
  }
  if ((0, _lodash.isArray)(value)) {
    return value;
  }
  return [value];
};
var QueryUtils = {
  useQuery: useQuery,
  buildQuery: buildQuery,
  castArray: castArray
};
exports.QueryUtils = QueryUtils;